module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1009-63cc000aaea085f69378675d57036bac.png";